export default __webpack_public_path__ + "static/media/Slide1.1ad5a539.png";